import { useTranslation } from "react-i18next";
import HistorySectionLayout from "../../components/History/HistorySectionLayout";
import TradeHistoryTable from "../../components/History/TradeHistoryTable";
import { useTradeHistory } from "../../hooks/api/history/useTradeHistory";
import { useUrlInstrumentFilter } from "../../hooks/useUrlParamState";
import { AssetResponse } from "../../utils/asset";

interface ITradeHistoryTabProps {
  mode?: "portfolio" | "trading";
  hideTitle?: boolean;
  hideFilter?: boolean;
  /**
   * Server-side market scope for the "show selected market only" toggle. When
   * set, pins the query to the current market's asset (mirrors Positions/Open
   * Orders). Asset only — no instrument-type constraint, so spot + perp for the
   * asset are both included.
   */
  assetFilter?: AssetResponse;
}

export function TradeHistoryTab({
  mode = "portfolio",
  hideTitle,
  hideFilter,
  assetFilter,
}: ITradeHistoryTabProps = {}) {
  const { t } = useTranslation("app", {
    keyPrefix: "pages.TradeHistoryTab",
  });
  const [filter, setFilter] = useUrlInstrumentFilter(
    "tab",
    mode === "portfolio"
  );
  const data = useTradeHistory({
    instrumentType: filter,
    asset: assetFilter,
  });

  return (
    <HistorySectionLayout
      title={t("trade_history", { defaultValue: "Trade History" })}
      mode={mode}
      hideTitle={hideTitle}
      filter={filter}
      onSetFilter={hideFilter ? undefined : setFilter}
    >
      {(tableHeight) => (
        <TradeHistoryTable
          items={data.items}
          isLoading={data.isLoading}
          isLoadingMore={data.isLoadingMore}
          hasMore={data.hasMore}
          onLoadMore={data.loadMore}
          height={tableHeight}
        />
      )}
    </HistorySectionLayout>
  );
}
